import { Controller } from "@hotwired/stimulus"

// Bloqueia o submit do form se o campo `field` estiver vazio, exibindo um
// aviso (swal) em vez de enviar. Ligue a action ao click do botão de envio.
export default class extends Controller {
  static targets = ["field"]
  static values = { message: String }

  submit(event) {
    event.preventDefault()
    if (this.fieldTarget.value) {
      this.element.requestSubmit()
    } else {
      window.notify("error", this.messageValue)
    }
  }
}
